var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AfyButton, AfyModal } from "@affinitysystemsgroup/assurehub-ui";
import { REJECTION_CODES_TEXT } from "../../../constants/rejectionCodes.constants";
import { ConfirmActionModalActions, ConfirmActionModalMessage, ConfirmActionModalTitle, } from "../style/confirmActionModal.style";
export var ConfirmActionModalView = function (props) { return (_jsxs(AfyModal, __assign({ opened: props.opened, onClose: props.onClose, title: _jsx(ConfirmActionModalTitle, { children: props.title }), size: "30%" }, { children: [_jsx(ConfirmActionModalMessage, { children: props.message }), _jsxs(ConfirmActionModalActions, { children: [_jsx(AfyButton, { label: REJECTION_CODES_TEXT.cancelButton, variant: "default", onClick: props.onClose, disabled: props.loading }), _jsx(AfyButton, { label: props.confirmLabel, color: "red", variant: "filled", onClick: props.onConfirm, loading: props.loading })] })] }))); };
